import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Female, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import messageUtil from 'utils/messageUtil'
import Gender from 'enums/Gender'
import MetadataIconsContainer from './MetadataIconsContainer'

const FemaleIcon = () => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const color = sys[theme].semantic.female.default
  const message = messageUtil.gendersIconMessage(Gender.FEMALE)
  const tooltip = `${t('authorsGender')}: ${message}`

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={message}>
          <Female color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default FemaleIcon
